import { ModelBase } from 'store/model-base';

import { BYOD_INCOMPATIBLE_CODES, BYOD_LOST_STOLEN_CODE, BYOD_SOFTWARE_INCOMPATIBLE_CODES, ByodEligibleStatus, ESimCapabilityStatus, SimType } from 'my-account/constants';

export class ByodEligibility extends ModelBase {
    public static storeName: string = 'byodEligibility';
    public deviceImei: string;

    public conditionalReasons: EligibilityReason[];
    public denialReasons: EligibilityReason[];
    public eligibleStatus: ByodEligibleStatus;
    public byodEligible: boolean;
    public sku: string;
    public byodCompatibilityStatus: string;
    public imeiCapability: string;
    public alternateImeiCapability: string;
    public esimcapabilityStatus: string;

    public byodReasons: EligibilityReason[];
    public byodDenialReasonCodes: string[];

    public messages: Message[];

    public isUpdateCompatible: boolean;
    public isAppleLocked: boolean;
    public isAppleLockedBYO2000: boolean;
    public isAndroidLocked: boolean;

    public isLostStolen: boolean;
    public isIncompatible: boolean;
    public isESIM: boolean;
    public isPSIM: boolean;

    public static create<T extends ModelBase>(initData: object = {}): T {
        const toReturn: ByodEligibility = super.create<ByodEligibility>(initData);
        if (!toReturn.denialReasons) {
            toReturn.denialReasons = [];
        }

        toReturn.byodDenialReasonCodes = toReturn.denialReasons.map((reason: EligibilityReason) => reason.code);

        if (!toReturn.conditionalReasons) {
            toReturn.conditionalReasons = [];
        }

        toReturn.byodReasons = [ ...toReturn.denialReasons, ...toReturn.conditionalReasons ];

        toReturn.isIncompatible = toReturn.byodReasons.some((reason: EligibilityReason) => BYOD_INCOMPATIBLE_CODES.includes(reason.code));
        toReturn.isUpdateCompatible = toReturn.byodReasons.some((reason: EligibilityReason) => BYOD_SOFTWARE_INCOMPATIBLE_CODES.includes(reason.code));
        toReturn.isLostStolen = toReturn.byodReasons.some((reason: EligibilityReason) => BYOD_LOST_STOLEN_CODE.includes(reason.code));
        toReturn.isAppleLocked = toReturn.byodReasons.some((reason: EligibilityReason) => reason.code === 'BYO200' || reason.code === 'BYO1400');
        toReturn.isAppleLockedBYO2000 = toReturn.byodReasons.some((reason: EligibilityReason) => reason.code === 'BYO2000');
        toReturn.isAndroidLocked = toReturn.byodReasons.some((reason: EligibilityReason) => reason.code === 'BYO1900');

        toReturn.isESIM = (toReturn.imeiCapability === SimType.ESIM || toReturn.imeiCapability === SimType.PSIM_ESIM) && toReturn.esimcapabilityStatus === ESimCapabilityStatus.CONFIRMED;
        toReturn.isPSIM = toReturn.imeiCapability === SimType.PSIM;

        /* eslint-disable @typescript-eslint/no-explicit-any */
        return <T> <any> toReturn;
        /* eslint-enable @typescript-eslint/no-explicit-any */
    }

}
